import React from "react";
import PropTypes from "prop-types";
import { Button, makeStyles } from "@fluentui/react-components";
import { Dismiss20Filled } from "@fluentui/react-icons";
import { useIntl } from "react-intl";
import { useParticipantLayoutControls } from "../layout/participant-layout/ParticipantLayoutContext";

const useStyles = makeStyles({
  floatyButtonsContainer: {
    position: "absolute",
    top: "20px",
    right: "20px",
    zIndex: 20,
    display: "flex",
    flexDirection: "row-reverse",
    gap: "10px"
  },
  participantLayoutCloseButton: {
    height: "40px",
    minWidth: "40px",
    backgroundColor: "var(--toolbar-overlay-background)",
    "& span": {
      width: "24px",
      height: "24px",
      fontSize: "24px"
    },
    "& svg": {
      color: "var(--colorNeutralForeground1)",
      fill: "currentColor"
    }
  }
});

export function FloatyButtonsContainer({ children }) {
  const classes = useStyles();
  const intl = useIntl();
  const { active: participantLayoutActive, onRequestClose } = useParticipantLayoutControls();
  const closeParticipantLayoutLabel = intl.formatMessage({
    id: "participant-layout.close-2d-layout",
    defaultMessage: "Close 2D layout"
  });

  return (
    <div className={classes.floatyButtonsContainer}>
      {participantLayoutActive && onRequestClose && (
        <Button
          appearance="subtle"
          aria-label={closeParticipantLayoutLabel}
          className={classes.participantLayoutCloseButton}
          data-participant-layout-floaty-close-button=""
          icon={<Dismiss20Filled />}
          onClick={onRequestClose}
          title={closeParticipantLayoutLabel}
        />
      )}
      {children}
    </div>
  );
}

FloatyButtonsContainer.propTypes = {
  children: PropTypes.node
};
